import { TProps } from './types/TProps';

const rootClassName = [
  "relative inline-flex text-left font-['General_Sans',sans-serif] text-xs font-medium leading-3",
  '[&:focus-within_.icon]:text-[var(--color-title)]',
].join(' ');

const disabledClassName = ['pointer-events-none', '[&_.icon]:!text-[var(--color-form-field-disabled-icon)]'].join(' ');

export const FormFieldRoot = ({ disabled = false, className = '', children }: TProps) => (
  <span className={[rootClassName, className, disabled ? disabledClassName : ''].filter(Boolean).join(' ')}>
    {children}
  </span>
);
